import * as React from 'react';
import { VideoCard } from '../entities/video-card';
import { EntityCard } from '../entities/entity-card';
import { PostCard } from '../entities/post-card';
import { CitationCard } from '../entities/citation-card';
import { FeedEntryCard } from '../entities/feed-entry-card';
import { PersonCard } from '../entities/person-card';
import { OrganisationCard } from '../entities/organisation-card';
export var defaultEntityTypeCardsSet = {
  Entity: EntityCard,
  Organisation: OrganisationCard,
  Post: PostCard,
  Person: PersonCard,
  Citation: CitationCard,
  FeedEntry: FeedEntryCard,
  Video: VideoCard
};
export var EntityTypeCardsContext = React.createContext(defaultEntityTypeCardsSet);
export var EntityTypeCardsProvider = EntityTypeCardsContext.Provider;